
import {
    constants,
    getApi,
    deleteApi,
    postApi,
    putApi,
} from "../../helpers/Api/Index";
export const addPatient = (data: any) => {
    return postApi(constants.urls.PATIENT_ADD, data);
};

// export const addPatient = (data: any) => {
//     const payload = {
//         "patient_unique_number": data.patient_unique_number,
//         "name": data.name,
//         "father_or_mother_name": data.father_or_mother_name,
//         "aadhar_number": data.aadhar_number,
//         "contact_number": data.contact_number,
//         "height": data.height,
//         "weight": data.weight,
//         "bp": data.bp,
//         "sp02": data.sp02,
//         "fever": data.fever,
//         "first_visit":[data.first_visit],
//         "revisit": [data.revisit],
//         "total_amount": [{
//             "payment_date": data.payment_date,
//             "amount": data.total_amount
//         }]
//     }
//     return postApi(constants.urls.PATIENT_ADD, payload);
// };

export const editPatient = (data: any, id: string) => {
    return putApi(constants.urls.PATIENT_EDIT + "/" + id, data);

};
export const deletePatient = (id: string) => {
    return deleteApi(constants.urls.PATIENT_DELETE + "/" + id);
};
export const getPatientlist = (params: string = "") => {
    return getApi(constants.urls.PATIENT_LIST, params);
};


export const getByPatientId = (id: string) => {
    return getApi(constants.urls.PATIENT_GETBYID + "/" + id);
};

export const rollbackPatient = (id: string) => {
    return deleteApi(constants.urls.PATIENT_ROLLBACK + "/" + id);
};
export const deletePatientHard = (id: string) => {
    return deleteApi(constants.urls.PATIENT_DELETE_HARD + "/" + id + "?hard=true");
};

export const bookingHandymanDropdown = () => {
    return getApi(constants.urls.PATIENT_DROPDOWN).then((res: any) => res.map((item: any) => {
        return {
            id: item.id,
            label: item.name
        }
    }))
};
export const getStatusValue = async (id: any) => {
    let statusValues: any = await getPayment();
    let value = statusValues.find((x: any) => Number(x.id) === Number(id));
    return value['label'];
}
export const getPayment = () => {
    return new Promise((resolve, reject) => {

        resolve([
            {
                id: 0,
                label: "Pending"
            },
            {
                id: 1,
                label: "Completed"
            },
            {
                id: 2,
                label: "Rejected"
            }
        ])

    })
}

export const getTotalAmount = () => {
    return getApi(constants.urls.TOTAL_AMOUNT_LIST);
};

